<template>
    <div class="lni-c-content__wrapper lni-u-mhauto lni-u-flex lni-u-row lni-u-justify-between">
        <div
            v-if="isLoading"
            class="lni-u-text--center"
        >
            <lni-spinner
                id="home-spinner`"
                :inline="false"
            />
        </div>
        <lni-isolated-workers-complaint-form
            v-if="isInitialized"
            id="form"
        />
    </div>
</template>

<script>
export default {
    name: 'LniHomePage',
    computed: {
        isLoading() {
            return this.$store.state.appState?.isLoading ?? true;
        },
        isInitialized() {
            return this.$store.state.appState?.isInitialized;
        }
    },
    async mounted() {
        const endpoint = `${this.$oneLni.environment.current.apiLocation2}/isolated-workers-complaint`;

        await fetch(endpoint, {
            mode: 'cors',
        }).then(response => response.json()).then(data => {
            const text = data.results.data;
            const newTextValue = Object.entries(text).reduce((collector,[key, val]) => {
                collector[key] = val;
                return collector;
            }, {});
            // only write values that we have
            const textValue = {...this.$store.state.appState.text, ...newTextValue};
            this.$store.commit('appState/SET_VALUE', {
                key: 'text',
                value: textValue,
            }, { root: true });

            this.$store.commit('appState/SET_VALUE', {
                key: 'allegationsChecklistOptions',
                value: data.results.allegationsChecklistOptions,
            }, { root: true });

            this.$store.commit('appState/SET_VALUE', {
                key: 'complaintSubmissionLangOptions',
                value: data.results.complaintSubmissionLangOptions,
            }, { root: true });

            this.$store.commit('appState/SET_VALUE', {
                key: 'complaintSubmissionRoleOptions',
                value: data.results.complaintSubmissionRoleOptions,
            }, { root: true });

            this.$store.commit('appState/SET_VALUE', {
                key: 'counties',
                value: data.results.counties,
            }, { root: true });

            this.$store.commit('appState/SET_VALUE', {
                key: 'docUploadTypes',
                value: data.results.docUploadTypes,
            }, { root: true });
        });

        this.$store.commit('appState/SET_VALUE', {
            key: 'isLoading',
            value: false,
        });
        this.$store.commit('appState/SET_VALUE', {
            key: 'isInitialized',
            value: true,
        });
    },
}; </script>